import { Selectors } from "@/store/saloonProfile/selectors";
import { Selectors as BasketSelectors } from "@/store/basket/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Effects as BasketEffects } from "@/store/basket/effects";
import { connect } from "react-redux";
import Services from ".";

const mSp = (state, props) => ({
  services: Selectors.getServices(state, props.specs),
  authMasterId: UserSelectors.getMasterId(state),
  authUserId: UserSelectors.getUserId(state),
  basket: BasketSelectors.getBasket(state),
  isOwner: Selectors.isOwner(state),
  canEditServices: Selectors.canEditServices(state),
});
const mDp = {
  addToBasket: BasketEffects.addToBasket,
};

export default connect(mSp, mDp)(Services);
